import { IconCirclePlus, IconTag } from '@tabler/icons-react'
import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { getApi, postApi } from '../../../api/call.api'
import { urlApi } from '../../../api/url.api'
import IconButton from '../../../components/Buttons/IconButton'
import ConfirmationModal from '../../../components/ConfirmationModal/ConfirmationModal'
import TableComponent from '../../../components/DataTable/TableComponent'
import ToggleBtn from '../../../components/Toggle/ToggleBtn'
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller'
import CreateCannedReplyModal from '../Component/CannedReplyComponents/CreateCannedReplyModal'
import EditCannedReplyModal from '../Component/CannedReplyComponents/EditCannedReplyModal'

const CannedReply = () => {

    const [data, setData] = useState([])

    const columns = [
        { name: "Sl. No", center: "true", width: '50px', selector: (row) => row?._id, cell: (row, index) => (index + 1) },
        {
            name: "Message", selector: (row) => row?.message, cell: (row) => (
                <div className='py-2 px-2 text-start'>
                    <p className="mb-2">{row?.message ?? "--"}</p>
                    {row?.file && row?.messageType == 2 && <a href={row?.file} target='_blank' rel="noreferrer" className='!mb-1.5 border-1 border-orange-500 p-0.5 rounded-md me-3'>File Attached</a>}
                    {row?.voice && row?.messageType == 3 && <a href={row?.voice} target='_blank' rel="noreferrer" className='!mb-1.5 border-1 border-teal-500 p-0.5 rounded-md'>Audio Attached</a>}
                    {row?.tags?.length > 0 && <div className='flex items-center mt-3'>
                        <IconTag size={16} className='text-gray-500' />
                        <p className='text-xs mb-0 ps-1'>
                            {row?.tags?.map((item, index) => {
                                return (
                                    <span key={index} className='text-gray-600 border p-0.5 rounded-md me-1'>{item}</span>
                                )
                            })}</p>
                    </div>}
                </div>
            )
        }, {
            name: "Status", center: "true", selector: (row) => row?.action, grow: 0.1, cell: (row) => (
                <ConfirmationModal buttonComponent={<ToggleBtn state={row?.status == 1} />} onConfirm={() => updateStatus(row)} confirmationText={`Are you sure wants to ${row?.status == 1 ? 'Disable' : 'Enable'} ?`} />)
        }, {
            name: "Action", center: "true", selector: (row) => row?.action, grow: 0.1, cell: (row) => (
                <EditCannedReplyModal buttonComponent={<button className="mb-0 !border !px-2 !py-1 rounded">Edit</button>} rowData={row} callback={() => getList()} />)
        }]

    async function getList() {
        loadingShow();
        let resp = await getApi(urlApi.getCannedReplyList + "?page=1&limit=10");
        loadingHide();
        if (resp.responseCode === 200) {
            setData(resp.data);
        } else {
            setData([]);
        }
    }

    const updateStatus = async (rowData) => {
        loadingShow();
        let postData = {
            status: rowData?.status == 1 ? 2 : 1,
            cannedReplyId: rowData?._id
        }
        let resp = await postApi(postData, urlApi.updateStatusOfCannedReply)
        loadingHide();
        if (resp.responseCode === 200) {
            getList();
        } else {
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        getList();
    }, []);

    return (
        <>
            <div className='mb-3 flex items-center justify-between'>
                <div>
                    <p className='text-[17px] font-bold mb-0 text-[var(--grey)] px-2'>Canned replies</p>
                    {/* <p className='text-xs italic mb-0 text-gray-500 px-2'>*You can add maximum of 10 URLs .</p> */}
                </div>
                {<CreateCannedReplyModal buttonComponent={<IconButton icon={<IconCirclePlus size={20} />} text={"Add"} />} callback={() => getList()} />}
            </div>

            <TableComponent
                columns={columns}
                data={data}
                totalRows={data?.length}
                isHeader={true}
                isPagination={false}
                paginationPerPage={10}
                handlePageChange={(e) => { }}
                handlePerRowsChange={(newPerPage, page) => { }} />
        </>
    )
}

export default CannedReply